import type { IOrganizationRef } from '../../../Model/index.js'
import type React from 'react';
import { useState } from 'react'
import { Environment } from '../../../environment.js'

interface OrganizationLogoProps {
  organization: IOrganizationRef
}

const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((word) => word[0]?.toUpperCase())
    .join('')
    .slice(0, 3)
}

export const OrganizationLogo: React.FC<OrganizationLogoProps> = ({ organization }) => {
  const [logoError, setLogoError] = useState(false)


  if (logoError || !organization.logo) {
    return (
      <div className="max-h-48 max-w-full flex items-center justify-center bg-base-200 text-base-content text-4xl font-bold mx-auto rounded-sm">
        {getInitials(organization.name)}
      </div>
    )
  }

  return (
    <img
      src={`${Environment.LOGO_BASE_URL}/${organization.id}/logo/${organization.logo}`}
      alt={`${organization.name} logo`}
      className="max-h-48 max-w-full object-contain mx-auto"
      onError={() => setLogoError(true)}
    />
  )
}
